import React from "react";
import PropTypes from "prop-types";
import NavIcon from "./NavIcon";
import styles from "./NavIcons.module.css";
import {
  getNavIcon,
  getNavPartProps,
  isNavigationBarBrandRefresh,
} from "../navigationBarBrandRefreshClasses";

const legacyHamburgerIcon = require("./imgs/Hamburger.svg");
const brandRefreshHamburgerIcon = require("./imgs/brand-refresh-Hamburger.svg");

const HamburgerMenuIcon = ({ onClick }) => {
  const hamburgerIcon = getNavIcon(
    legacyHamburgerIcon,
    brandRefreshHamburgerIcon,
  );
  const isBrandRefresh = isNavigationBarBrandRefresh();

  return (
    <NavIcon onClick={onClick} ariaLabel="Open navigation menu">
      <img
        src={hamburgerIcon}
        alt=""
        className={isBrandRefresh ? undefined : styles.hamburgerIcon}
        data-part={getNavPartProps("hamburger-icon")}
      />
    </NavIcon>
  );
};

HamburgerMenuIcon.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default HamburgerMenuIcon;
